import { Button, FileInput, Grid, Group, Text } from "@mantine/core";
import { observer } from "mobx-react";
import React, { useImperativeHandle, useState } from "react";
import { useStore } from "../../stores/store";
import t from "../../stores/language";
import { faUpload } from "@fortawesome/pro-duotone-svg-icons";
import { Icon } from "../../custom-components/icons";
import theme from "../../stores/theme";
import Modal from "../../custom-components/model";
import { useStyles } from "./configure-input";
import { delay } from "./module-assumptions";
import PopConfirm from "../../custom-components/pop-confirm";
export interface LookupDataUploaderHandle {
  show: () => void;
}
const LookupDataUploader = observer(
  React.forwardRef<LookupDataUploaderHandle, unknown>(function LookupDataUploader(props, ref) {
    const { store } = useStore();
    const [selectedFile, setFile] = useState<File | null>(null);
    const [actionResult, setAction] = useState<{ isError: boolean; message: string }>({ isError: false, message: "" });
    const [visible, setVisible] = useState<boolean>(false);
    const [uploading, setUploading] = useState<boolean>(false);
    const { classes } = useStyles();
    useImperativeHandle(ref, () => {
      return {
        show: show,
      };
    });

    const show = () => {
      setVisible(true);
    };

    const uploadData = async () => {
      if (selectedFile == null) {
        setAction({ isError: true, message: t("Please Select File") });
        return;
      }
      setUploading(true);
      const result = await store.UploadLookupData(selectedFile);
      if (result.error) {
        setAction({ isError: true, message: result.message as string });
        setUploading(false);
        return;
      } else {
        setAction({ isError: false, message: result.message as string });
        await delay(400);
        setUploading(false);
      }
      resetState();
    };

    const clearAllData = async () => {
      const result = await store.DeleteAllLookupData();
      if (result) {
        setAction({ isError: false, message: t("Deleted All Master Data Successfully") });
        await delay(400);
      } else {
        setAction({ isError: true, message: t("Delete Failed") });
        return;
      }
      resetState();
    };

    const resetState = () => {
      setVisible(false);
      if (selectedFile != null) setFile(null);
      setAction({ isError: false, message: "" });
    };

    return (
      <Modal
        opened={visible}
        header={t("Master Data Upload")}
        footer={
          <Group className={classes.modalFooter}>
            <Button
              variant={"default"}
              onClick={() => {
                resetState();
              }}
            >
              {t("Cancel")}
            </Button>
            <Button onClick={() => uploadData()} loading={uploading}>
              {t("Upload")}
            </Button>
          </Group>
        }
        withCloseButton={true}
        onClose={() => {
          resetState();
        }}
        size={"35%"}
      >
        <Grid pb={15} pl={15} pr={15} columns={12} m={0}>
          <Grid.Col span={12}>
            <FileInput
              label={t("Master Data File")}
              value={selectedFile}
              onChange={(payload) => {
                if (payload != null && actionResult.isError) {
                  setAction({ isError: false, message: "" });
                }
                setFile(payload);
              }}
              clearable
              icon={<Icon icon={faUpload} />}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <PopConfirm confirmText={t("Are You Sure?")} position="bottom-start" width={180} onConfirm={() => clearAllData()}>
              <Button color="red" variant="filled">
                {t("Delete All Data")}
              </Button>
            </PopConfirm>
          </Grid.Col>
          {actionResult.message !== "" ? (
            <Grid.Col span={12}>
              <Text size={theme.fontSizes?.sm} color={actionResult.isError ? "red" : "green"}>
                {actionResult.message}
              </Text>
            </Grid.Col>
          ) : null}
        </Grid>
      </Modal>
    );
  })
);
export default LookupDataUploader;
